import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { Ticket, TicketRecordType } from 'src/app/models/ticket/ticket.model';

@Component({
  selector: 'app-ticket-detail-service',
  templateUrl: './ticket-detail-service.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TicketDetailServiceComponent {
  readonly ticket = input.required<Ticket>();

  readonly TicketRecordType = TicketRecordType;

  readonly showFullDescription = signal(false);

  readonly isDescriptionLong = computed(() => {
    const desc = this.ticket().Description ?? '';
    return desc.length > 120 || desc.includes('\n');
  });

  toggleDescription(): void {
    this.showFullDescription.update((v) => !v);
  }
}
